/* esm.sh - @radix-ui/react-slot@1.3.3 */
export * from "/*@radix-ui/react-slot@1.3.3/esnext/react-slot.mjs";
